export default {
  user_module_userManagement_home: {
    path: 'user-management/:moduleBridgeHex/home/:page/',
    parameters: {
      moduleBridgeHex: undefined,
      page: 1,
    },
  },
  user_module_userManagement_userInfo: {
    path: 'user-management/:moduleBridgeHex/:userName/info/',
    parameters: {
      moduleBridgeHex: undefined,
      userName: undefined,
    },
  },
  user_module_userManagement_add: {
    path: 'user-management/:moduleBridgeHex/add/:userName/',
    parameters: {
      moduleBridgeHex: undefined,
      userName: undefined,
    },
  },
  user_module_userManagement_edit: {
    path: 'user-management/:moduleBridgeHex/edit/:userName',
    parameters: {
      moduleBridgeHex: undefined,
      userName: undefined,
    },
  },
};
